import React from 'react';
import { FiMail, FiSend } from 'react-icons/fi';
import { WidgetDef } from '../types';
import { DemoHead, useWidgetSite } from '../shared';
import { toast } from '../../../Toast';

// spec 623:5285 — no settings: the questions and spam handling live in Website Hub › Contact forms
const contactForm: WidgetDef = {
    slug: 'contact-form',
    name: 'Contact form',
    description: 'Sends enquiries into Website Hub › Contact forms',
    icon: <FiMail />,
    title: 'Contact Form Widget',
    installed: true,
    page: '/contact-us/',
    views: 190,
    demoPath: '/contact-us/',
    addNote: 'One code, nothing to configure here. What the form asks and how spam is handled is set in Website Hub › Contact forms › Form settings, and the form on the website updates itself.',
    addBlocks: [
        { title: '1 · WordPress shortcode', code: '[investi_contact_form instance="contact-form"]' },
        { title: '2 · Or plain HTML', code: '<div data-investi-instance="contact-form" data-investi="contact-form"></div>', dark: true },
    ],
    Demo: () => {
        const { host } = useWidgetSite();
        const submit = (e: React.FormEvent) => {
            e.preventDefault();
            toast.info('Preview only: nothing was sent');
        };
        return <form className="wd-contact" onSubmit={submit}>
            <DemoHead title="Contact us" sub="Messages come straight to the company" />
            <div className="fields">
                <label><span>Your name</span><input placeholder="Kenneth Parker" /></label>
                <label><span>Email address</span><input type="email" placeholder="you@example.com" /></label>
                <label><span>Phone number (optional)</span><input type="tel" placeholder="+61 …" /></label>
                <label><span>Company / organisation (optional)</span><input placeholder="Company name" /></label>
                <label className="wide"><span>What is your enquiry about?</span><input placeholder="Shareholding enquiry" /></label>
                <label className="wide"><span>Message</span><textarea rows={3} placeholder="Tell us how we can help…" /></label>
            </div>
            <label className="check"><input type="checkbox" /> Also send me announcements by email. You can unsubscribe at any time.</label>
            <button type="submit" className="send"><FiSend /> Send Message</button>
            <p className="foot">Protected by Investi’s spam filter · replies come from investors@{host}</p>
        </form>;
    },
};

export default contactForm;
